module.exports = __webpack_public_path__ + "static/03-5b9b56568f0222250edf5c1676e50edb.jpg";